module.exports = __webpack_public_path__ + "static/img/15.c26521c.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/5/1/zh/15.png
// module id = blZW
// module chunks = 0